export const TOGGLE_CART = 'TOGGLE_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART_BULK = 'ADD_TO_CART_BULK';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const GET_ALL_CART_DATA = 'GET_ALL_CART_DATA';
export const ADD_TO_CART_BUY_NOW = 'ADD_TO_CART_BUY_NOW';